module.exports = __webpack_public_path__ + "media/images/athletes/3203-3d17241029cdb45a61ec4adf896912c9.png";